import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import type { JugadorParaFinalizar } from "@/utils/rankings";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalFinalizarCompetencia',
  props: {
  visible: Boolean,
  jugadores: {
    type: Array as () => JugadorParaFinalizar[],
    default: () => [],
  },
  tipoCompetencia: {
    type: String as () => "Torneo" | "Liga",
    default: "Torneo",
  },
  nombreCompetencia: String,
  categoria: String,
  genero: String,
  idRanking: {
    type: [Number, undefined],
  },
},
  emits: ["close", "finalizar"],
  setup(__props, { emit }) {

const props = __props;





const puntosMaximos = computed(() => {
  if (!props.jugadores.length) return 0;
  return Math.max(...props.jugadores.map((j) => j.puntosAsignados || 0));
});

const puntosTotal = computed(() => {
  return props.jugadores.reduce((sum, j) => sum + (j.puntosAsignados || 0), 0);
});

const title = computed(() => {
  return !props.idRanking
    ? `Finalizar ${props.tipoCompetencia}`
    : "Actualizar puntos";
});

function getColorOrden(orden: number): string {
  if (orden === 1) return "amber darken-1";
  if (orden === 2) return "grey lighten-1";
  if (orden === 3) return "orange darken-3";
  return "grey";
}

function esSegundoDePareja(index: number): boolean {
  if (index === 0) return false;

  const jugadorActual = props.jugadores[index];
  const jugadorAnterior = props.jugadores[index - 1];

  return jugadorActual.ordenMerito === jugadorAnterior.ordenMerito;
}

function finalizar() {
  emit("finalizar", props.jugadores);
}

function onlyNumber($event: any) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if (keyCode < 48 || keyCode > 57) {
    $event.preventDefault();
  }
}

return { __sfc: true,props, emit, puntosMaximos, puntosTotal, title, getColorOrden, esSegundoDePareja, finalizar, onlyNumber }
}

})